import React from "react";
import SmallLoader from "../../Components/Common/smallLoader";

function ReportTableHeader(props) {
  let handleOnClick = props.handleOnClick;

  return (
    <>
      <div className="table-top-nav">
        <div className="table-dt-btn">
          {props.showEmailBtn ? (
            <button
              value="mail"
              onClick={handleOnClick}
              className="generate-button mail-btn"
            >
              {props.smallLoaderMail ? (
                // <div>
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>
          ) : (
            ""
          )}
          <button
            value="excel"
            onClick={handleOnClick}
            className="generate-button excel-btn"
          >
            {" "}
            {props.smallLoaderExcel ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {"Excel"}
              </>
            )}
          </button>
          {props.showPdfBtn === false ?
          "": (
          <button
            className="generate-button pdf-btn"
            value="pdf"
            onClick={handleOnClick}
          >
            {props.smallLoaderPdf ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-pdfsvg"></span>
                {"PDF"}
              </>
            )}
          </button>
           )}
        </div>
      </div>
    </>
  );
}

export default ReportTableHeader;
